import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext } from "react";
import MobileNotice from "./notice/MobileNotice";
import DeskTopNotice from "./notice/DeskTopNotice";

function Notice(props) {
    const { type } = props;
    const { isMobile } = useContext(BrowserDetectContext);
    return (
        isMobile
            ?
            <MobileNotice type={type} />
            :
            <DeskTopNotice type={type} />
    );
}

export default Notice;